/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { Button } from 'reactstrap';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { BulkActionToolbarSelectedUtrv } from './BulkActionToolbar';
import { Column } from '@g17eco/molecules/tracking-list';

interface ColumnSelectboxProps extends ColumnCommonProps {
  isSelected: boolean;
  toggleSelectQuestion: (utrv: BulkActionToolbarSelectedUtrv) => void;
  disabled?: boolean;
}

export const ColumnSelectbox = (props: ColumnSelectboxProps) => {
  const { question, isSelected, toggleSelectQuestion, disabled = false } = props;
  const { universalTracker } = question;
  if (!question.utrv) {
    return null;
  }

  const utrv = question.utrv;

  const utr = {
    name: universalTracker.getName(),
    valueType: universalTracker.getValueType(),
    valueValidation: universalTracker.getValueValidation(),
    unit: universalTracker.getMetricUnitCode(),
    unitType: universalTracker.getMetricUnitType(),
    numberScale: universalTracker.getNumberScale(),
  }

  return (
    <Column className='question-list__select-box' >
      <Button disabled={disabled} color='link' onClick={() => toggleSelectQuestion({...utrv, utr })} className='p-0'>
        <i className={`${isSelected ? 'fa-solid fa-square-check text-ThemeAccentMedium' : 'fa-light fa-square text-ThemeNeutralsDark'}`} />
      </Button>
    </Column>
  );
}
